import store from "@src/store";
import { cartSlice } from "@src/store/reducers/CartSlice";
import isWebView from "@src/lib/WebView/isWebView";

const FIRST_INTERACTION_KEY = "__firstInteraction";

/**
 * Délégation clic sur cartes Static/SSR listing.
 * Couvre le 1er clic avant hydratation React des handlers onClick.
 */
export function installSsrListingProductOpen(): () => void {
  if (typeof document === "undefined") {
    return () => undefined;
  }

  const onClick = (event: MouseEvent) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const card = target.closest<HTMLElement>(
      "[data-ssr-listing] [data-id-product], [data-static='true'] [data-id-product]"
    );
    if (!card) return;

    const id_product = card.getAttribute("data-id-product") || undefined;
    const uri = card.getAttribute("data-product-uri") || undefined;
    if (!id_product) return;

    if (isWebView()) {
      event.preventDefault();
      event.stopPropagation();
      window.location.href = `sushishop://product?id_product=${encodeURIComponent(
        id_product
      )}`;
      return;
    }

    // uri peut manquer sur HTML SSR d'un build antérieur — id suffit pour ProductModal.
    // @ts-expect-error flag global AfterInteraction
    window[FIRST_INTERACTION_KEY] = true;
    window.dispatchEvent(new Event("rs-force-after-interaction"));

    store.dispatch(
      cartSlice.actions.openProductPage({
        id_product,
        uri: uri || undefined,
        noHiddenNavigation: true,
      })
    );
  };

  document.addEventListener("click", onClick, true);
  return () => document.removeEventListener("click", onClick, true);
}
